import script from "./AppCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppCard.vue?vue&type=script&setup=true&lang=ts"

import "./AppCard.vue?vue&type=style&index=0&id=ca98f97e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ca98f97e"]])

export default __exports__